module.exports = __webpack_public_path__ + "static/img/loader.91fd0e0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader.gif
// module id = M7I8
// module chunks = 11